import request from '@/utils/request'

/**
 * 获得媒体管理分页
 * @param {Object} params 查询参数
 * @param {number} params.pageNo 页码，从 1 开始
 * @param {number} params.pageSize 每页条数，最大值为 200
 * @param {string} params.mediaType 媒体类型
 * @param {string} params.mediaListTop 列表是否置顶
 * @param {string} params.mediaIndexTop 首页是否置顶
 * @returns {Promise}
 */
export function getMediaPage(params) {
  // GET 请求，参数通过 query parameters 传递
  // 虽然 OpenAPI 规范中写了 requestBody，但 GET 请求通常使用 query parameters
  return request({
    url: '/api/media/page',
    method: 'get',
    params: params
  })
}

/**
 * 获得媒体管理详情
 * @param {number} id 编号
 * @returns {Promise}
 */
export function getMediaDetail(id) {
  return request({
    url: '/api/media/detail',
    method: 'get',
    params: {
      id
    }
  })
}

/**
 * 获得当前id排序的上一条媒体管理
 * @param {number} id 编号
 * @returns {Promise}
 */
export function getMediaLast(id) {
  return request({
    url: '/api/media/last',
    method: 'get',
    params: {
      id
    }
  })
}

/**
 * 获得当前id排序的下一条媒体管理
 * @param {number} id 编号
 * @returns {Promise}
 */
export function getMediaNext(id) {
  return request({
    url: '/api/media/next',
    method: 'get',
    params: {
      id
    }
  })
}

